import { TFunction } from 'i18next'
import React, { PropsWithChildren } from 'react'
import AppBar from '../../../components/layout/AppBar'
import { PageWrapperProps } from '../PageWrapper'

interface NativePageLayoutProps extends PageWrapperProps {
	t: TFunction<'pages', undefined>
}

const NativePageLayout = ({
	children,
	page,
	appBarOptions,
	t,
}: PropsWithChildren<NativePageLayoutProps>) => {
	return (
		<>
			<AppBar
				label={appBarOptions?.label ?? t(page as any)}
				navigationType={appBarOptions?.closeFunction || appBarOptions?.backPath ? 'back' : 'menu'}
				{...appBarOptions}
			/>
			<div
				id={page.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase()}
				className={`layout-sm pt-0 min-w-full max-w-[1200px] mx-auto flex-1`}
			>
				{children}
			</div>
		</>
	)
}

export default NativePageLayout
